import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';
import { PRIMARY_FONT_COLOR, BLUE_FONT_COLOR, SMALL_TEXT_PX, FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR, BASE_TEXT_PX
    } from 'src/styles/fonts/MCFontConstants';
export const VerticalLine = styled.div`
    margin: 0 5px;
    display: inline;
    font-family: 'FONT_FAMILY_REGULAR';
`;

export const Dot = styled.span`
    height: 8px;
    width: 8px;
    margin: 0px 11px;
    background-color: #12c8f7;
    border-radius: 50%;
    display: inline-block;
`;

export const FullPageGrid = styled.div`
    display: grid;
    grid-template-columns: 32.25% 32.25% 32.25%;
    grid-auto-rows: ${(props) =>
        props.fixedRowHeight ? props.fixedRowHeight : ''};
    justify-content: normal;
    width: 100%;
    column-gap: 15px;
    row-gap: 15px;
    overflow-x: hidden;
    margin-top: 10px;
    ${media.mediumDevice`
        grid-template-columns: 49% 49%;
        column-gap: 10px;
        row-gap: 10px;
        margin-top: 0;
    `}
    ${media.smalDevice`
        grid-template-columns: 49% 49%;
         column-gap: 10px;
        row-gap: 10px;
    `}
    @media only screen and (min-device-width: 667px) and (max-device-width: 1023px) and (orientation : landscape) {
        width: ${({ ipadwidth }) => ipadwidth};
        height: ${({ landscapeHeight }) => landscapeHeight};
        column-gap:${({ landscapeColumnGap }) => landscapeColumnGap};
    }
    ${media.mobileDevice`
        grid-template-columns: 100%;
        row-gap: ${({ rowGap }) => (rowGap ? rowGap : '15px')};
        margin-bottom: ${(props) => props.mbMarginBottom};
        padding: ${(props) => props.padding}
    `}
     //ipad Air portrait
    @media only screen and (min-device-width: 820px) and (max-device-width: 820px) and (orientation: portrait) {
        column-gap: 10px;
        row-gap: 10px;
        grid-template-columns: 49% 49%;
    }
    //ipad Air landscape
    @media only screen and (min-device-width: 1180px) and (max-device-width: 1180px) and (orientation: landscape) {
        grid-template-columns: 32% 32% 32%;
    }
    //ipad Pro(10.5 inch) portrait
    @media only screen and (min-device-width: 834px) and (max-device-width: 834px) and (orientation: portrait) {
        grid-template-columns: 49% 49%;
        row-gap: 10px;
    }

    //ipad Pro(10.5 inch) landscape
    @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) and (-webkit-max-device-pixel-ratio: 2) {
        grid-template-columns: 32% 32% 32%;
        grid-auto-rows: ${({ gridAutoRows }) =>
            gridAutoRows ? gridAutoRows : null};
        padding-right: 10px;
    }

    @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
        grid-template-columns: 49% 49%;
    }
`;

export const StyledForm = styled.form`
    width: 100%;
`;

export const scrollBarStyle = css`
    &::-webkit-scrollbar {
        display: ${(props) => (props.display ? props.display : 'block')};
        width: ${(props) =>
            props.scrollBarWidth ? props.scrollBarWidth : '10px'};
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${(props) =>
            props.scrollBarBackgroundColor
                ? props.scrollBarBackgroundColor
                : '#00000029'};
        border-radius: ${(props) =>
            props.scrollBarBorderRadius ? props.scrollBarBorderRadius : '20px'};
        height: ${(props) => props.scrollbarHeight && props.scrollbarHeight};
    }
    &::-webkit-scrollbar-track {
        margin: ${(props) =>
            props.scrollbarTrackMargin && props.scrollbarTrackMargin};
        background: ${(props) =>
            props.scrollBarTrackBackGroundColor &&
            props.scrollBarTrackBackGroundColor};
    }
    &::-webkit-scrollbar-thumb:hover {
        background: ${(props) =>
            props.scrollBarBackGroundColorOnHover &&
            props.scrollBarBackGroundColorOnHover};
    }
    @media screen and (max-width: 390px) {
        &::-webkit-scrollbar {
            display: ${(props) =>
                props.mediumDeviceScrollBarDisplay
                    ? props.mediumDeviceScrollBarDisplay
                    : 'none'};
        }
    }
    @media screen and (max-width: 1024px) {
        &::-webkit-scrollbar {
            display: ${(props) =>
                props.mobileDeviceScrollBarDisplay
                    ? props.mobileDeviceScrollBarDisplay
                    : 'none'};
        }
    }
`;

export const astriskStyle = css`
    &:after {
        content: '${(props) => (props.showAstrisk ? '*' : '')}';
        color: red;
        padding-left: 3px;
    }
`;

export const StyledOrderDetailIPadPortrait = css`
    @media only screen and (min-device-width: 768px) and (max-device-width: 850px) and (orientation: portrait) {
        border-top-right-radius: ${({ iPadPortraitBorderTopRightRadius }) =>
            iPadPortraitBorderTopRightRadius};
        border-top-left-radius: ${({ iPadPortraitBorderTopLeftRadius }) =>
            iPadPortraitBorderTopLeftRadius};
        background: ${({ iPadPortraitBackgroundColor }) =>
            iPadPortraitBackgroundColor};
        position: ${({ iPadPortraitFooterPosition }) =>
            iPadPortraitFooterPosition};
        justify-content: ${({ iPadPortraitJustifyContent }) =>
            iPadPortraitJustifyContent};
    }
`;

/* collapsable card component style --start */
export const CollapsableCardRowHeader = styled.div`
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${({
        isExpanded,
        isConsignment,
        consignmentAdd,
        marginBottom,
        isTemplate,
    }) =>
        marginBottom
            ? '5px'
            : isExpanded
            ? isConsignment
                ? '10px'
                : consignmentAdd
                ? '0px'
                : isTemplate
                ? '-15px'
                : '16px'
            : '0px'};
    opacity: ${({ opacity }) => (opacity ? opacity : 'none')};
    cursor: pointer;
    pointer-events: ${(props) => props.pointerEvents};
    width: ${({ width }) => width};
    ${media.mobileDevice`
        width: ${({ mbHeaderWidth }) => mbHeaderWidth};
        margin: ${({ mbHeaderMargin }) => mbHeaderMargin};
        margin-bottom: ${({ mbMarginBottom }) => mbMarginBottom};
    `}
    ${media.mediumDevice`
        ${({ tabletMarginBottom }) => tabletMarginBottom ? `margin-bottom: ${tabletMarginBottom};` : ''}
    `}
`;

export const CollapsableCardTitle = styled.div`
     font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : FONT_FAMILY_DEMI}; 
    cursor: ${({ cursor }) => cursor && cursor};
    margin-left: ${({ marginLeft }) => marginLeft && marginLeft};
    font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 'unset')};
   color: ${({ fontColor }) => (fontColor ? fontColor : PRIMARY_FONT_COLOR)};
   font-size: ${({ fontSize }) => (fontSize ? fontSize : SMALL_TEXT_PX)};
    border-bottom: ${({ borderBottom }) =>
        borderBottom ? borderBottom : 'none'};
    border-bottom-width: ${({ borderBottomWidth }) =>
        borderBottomWidth ? borderBottomWidth : 'none'};
    &:after {
        content: '${(props) => (props.showAstrisk ? '*' : '')}';
        color: red;
        padding-left: 3px;
    }

    ${media.smalDevice`
        font-size: ${({ fontSizeMobile }) =>
            fontSizeMobile ? fontSizeMobile : SMALL_TEXT_PX}; 
            line-height: ${({ lineHeightMob }) =>
                lineHeightMob ? lineHeightMob : '27px'};
    `}

    ${astriskStyle};
`;

export const CollapsableCardImageContainer = styled.img`
    transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : '')};
    cursor: ${({ cursor }) => (cursor ? cursor : ' ')};
    display: ${(props) => props.display};
    width : 16px;
    ${media.smalDevice`
        margin: ${({ smMargin }) => smMargin};
        margin-right: ${({ marginRight }) => marginRight && marginRight};
    `}
    ${media.mobileDevice`
        margin: ${({ mbMargin }) => mbMargin};
            margin-right: ${({ marginRight }) => marginRight && marginRight};

    `}
    ${media.mediumDevice`
    margin: ${({ mdMargin }) => mdMargin};
`}
`;
/* collapsable card component style --end */
export const CommonEmptyBox = styled.div`
    margin: ${({ margin }) => margin};
    padding: ${({ webPadding }) => webPadding};
    ${media.smalDevice`
        margin: ${({ smMargin }) => smMargin};
    `}
    ${media.mobileDevice`
        margin: ${({ mobileMargin }) => mobileMargin};
        padding: ${({ mobilePadding }) => mobilePadding}; 
    `}
`;

export const LabelFont = styled.p`
    width: ${({ width }) => width};
    margin: ${({ margin }) => (margin ? margin : '0')};
    padding: ${({ padding }) => (padding ? padding : '0rem')};
    display: ${({ display }) => (display ? display : 'inline-block')};
    font-family: ${({ fontFamily }) => fontFamily};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    font-style: ${({ fontStyle }) => fontStyle};
    color: ${({ color }) => (color ? color : '#000000')};
    text-align: ${({ textAlign }) => textAlign};
    text-decoration: ${({ textDecoration }) =>
        textDecoration ? textDecoration : 'none'};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '0px'};
    line-height: ${({ lineHeight }) => lineHeight};
    opacity: ${({ opacity }) => (opacity ? opacity : 1)};
    cursor: ${({ cursor }) => (cursor ? cursor : 'auto')};
    text-overflow: ${({ textOverflow }) => textOverflow};
    overflow: ${({ overflow }) => overflow};
    white-space: ${({ whiteSpace }) => whiteSpace};
    -webkit-line-clamp: ${({ lineClamp }) => lineClamp};
    -webkit-box-orient: ${({ orient }) => orient};
    word-break: ${({ wordBreak }) => wordBreak};
    align-items: ${({ alignItems }) => alignItems && alignItems};
    ${media.mediumDevice`
        display: ${({ mdDisplay }) => mdDisplay};
        -webkit-line-clamp: ${({ mdLineClamp }) => mdLineClamp};
        width: ${({ mdWidth }) => mdWidth};
        font-style: ${({ mdFontStyle }) => mdFontStyle};
        font-size: ${({ mdFontSize }) => (mdFontSize ? mdFontSize : '13px')};
        line-height: ${({ mdLineHeight }) => mdLineHeight};
        white-space: ${({ mdWhiteSpace }) => mdWhiteSpace};
        -webkit-box-orient: ${({ mdOrient }) => mdOrient};
    `}
`;

export const OrderListDataContainer = styled.div`
    display: flex;
    height: ${({ height }) => (height ? height : 'auto')};
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    width: ${({ width }) => (width ? width : '100%')};
    margin: ${({ margin }) => (margin ? margin : '0')};
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'flex-start'};
    align-items: ${({ alignItems }) => alignItems};
    padding: ${({ padding }) => (padding ? padding : '0')};
`;

export const AlertMsg = styled.div`
    font-family: AvenirNextWorld Regular;
    color: red;
    font-size: 12px;
`;
